import _ from "lodash";

import { useMerchant } from "../../../store/global/useMerchant";
import { MerchantModel } from "../../models/global";
import { canLoadStoreContext } from "../../auth";

export default class MerchantController {
  _default = {
    name: "",
    cnpj: "",
    location: {
      uf: "",
      city: "",
      postalCode: "",
      street: "",
      number: "",
      complement: "",
      neighborhood: "",
    },
    planTypes: [],
    modules: [],
    contact: {
      phoneNumber: "",
      whatsapp: "",
    },
  };

  setMerchantValues = useMerchant.getState().actions.setMerchant;

  constructor() {
    this.MMerchant = MerchantModel();
  }

  initializeStore = _.once(() => this.load());

  init = () => {
    if (!canLoadStoreContext()) return;
    return this.initializeStore();
  };

  load = () => {
    if (!canLoadStoreContext()) return;
    this.setMerchantValues(this._default);
    return this.getStore();
  };

  getStore = async () => {
    return this.MMerchant.findMerchant();
  };
}
